import React from 'react'
import CartSvg from 'images/modules/Manage/i-cart.svg?raw'

export { default as CartUrl } from 'images/modules/Manage/i-cart.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: CartSvg}} />
)
